<template>
  <div class="ad">
    <div class="width1000 margintb">
      <div v-for="(item,index) in dataList.data"
           :index="index+''"
           :key="index">
        <a v-if="item.dataType=='article'"
           :href="'/h5/detail.html?artId='+item.dataVal"
           target="_blank "><img class="img"
               :src="item.imgUrl" />
        </a>
        <a v-else
           :href="item.dataVal"
           target="_blank "><img class="img"
               :src="item.imgUrl" />
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  },
  props: ['dataList'],
  mounted () {
  },
  watch: {
    dataList (val) {
      this.dataList = val;
      // console.log(this.dataList);
    }
  }
}
</script>
<style lang="less">
.ad {
  height: 90px;
  // overflow: hidden;
  img {
    width: 100%;
    height: 90px;
  }
}
</style>
